// TODO(rite): problem details convention?

export class ApiError extends Error {
    constructor(message, status) {
        super(message);
        this.status = status;
    }
}

export class ApiClient {
    static #MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB

    /**
     * @param {string} mediaUrl media URL to upload subtitles for
     * @param {File} file file to upload
     * @returns {Promise<{error: ApiError, data: null}> | Promise<{error: null, data: {fileName: string, userName: string, createdAt: Date, mediaUrl: string}}>} result
     */
    static async uploadSubtitles(mediaUrl, file) {
        if (file.size > this.#MAX_FILE_SIZE) {
            const errorMessage = `File size exceeds the limit of ${this.#MAX_FILE_SIZE / 1024 / 1024}MB`;
            return Promise.resolve({ error: new ApiError(errorMessage, 422), data: null });
        }

        const formData = new FormData();
        formData.append('file', file);

        /** @type {Request} */
        const request = {
            method: 'POST',
            body: formData,
            cache: 'no-cache'
        };

        return await ApiClient.#fetch(`/api/subtitles/${encodeURIComponent(mediaUrl)}`, request);
    }

    /**
     * @param {string} mediaUrl media URL to find subtitles for
     * @returns {Promise<{error: ApiError, data: null}> | Promise<{error: null, data: {fileName: string, userName: string, createdAt: Date, subtitleUrl: string}}>} result
     */
    static async tryFindSubtitles(mediaUrl) {
        if (!mediaUrl.startsWith('https://')) {
            return Promise.resolve({
                error: new ApiError('Only HTTPS URLs are supported', 422),
                data: null
            });
        }

        // TODO(rite): support more links and add validation handle
        if (!(mediaUrl.includes('drive.google.com') || mediaUrl.includes('docs.google.com'))) {
            return Promise.resolve({
                error: new ApiError('Only google drive links are supported', 422),
                data: null
            });
        }

        if (!this.#isValidUrl(mediaUrl)) {
            return Promise.resolve({ error: new ApiError('Invalid URL', 422), data: null });
        }

        /** @type {Request} */
        const request = {
            method: 'GET',
            cache: 'no-cache'
        };

        return await ApiClient.#fetch(`/api/subtitles/${encodeURIComponent(mediaUrl)}`, request);
    }

    static async #fetch(url, requestInfo) {
        let response;
        try {
            response = await fetch(url, requestInfo);
        } catch (e) {
            return { error: new ApiError(`Network error: ${e.message}`, 500), data: null };
        }
        if (!response.ok) {
            let errorData;
            try {
                errorData = await response.json();
            } catch {
                errorData = await response.text().catch(() => '');
            }
            const errorMessage = errorData.detail || errorData.title || `HTTP ${response.status}`;
            return { error: new ApiError(errorMessage, response.status), data: null };
        }

        return { error: null, data: await response.json() };
    }

    static #isValidUrl(string) {
        try {
            new URL(string);
            return true;
        } catch {
            return false;
        }
    }
}
